import PropTypes from "prop-types"

import { useClick } from "../hooks/useClick"
import { useData } from "../hooks/useData"
import { useSelect } from "../hooks/useSelect"
import { useVariants } from "../hooks/useVariants"
import { Row, TableDataCells } from "../styled"

/**
 * The table context aware table body
 */
export function TableBody() {
  const { data, firstRow } = useData()
  const { onRowClick, onCellClick } = useClick()
  const { selectedRowMap, onSelect } = useSelect()
  const variantData = useVariants()

  const handleRowClick = (event, data, row) => {
    if (onRowClick) {
      onRowClick({ data, row }, event)
    }

    if (onSelect) {
      onSelect({ row, data, selected: !Boolean(selectedRowMap[row]) }, event)
    }
  }

  const handleCellClick = (event, data, row, cell) => {
    if (onCellClick) {
      onCellClick({ data, row, cell }, event)
    }
  }

  const renderRow = (item, index, isFirstRow = false) => {
    const key = item?.key || item?.id || index

    return (
      <Row
        key={key}
        onClick={(e) => handleRowClick(e, item, index)}
        selected={isFirstRow ? selectedRowMap[0] : false}
        {...variantData}
      >
        {item?.map((itemData, cellIndex) => (
          <TableDataCells key={cellIndex} onClick={(e) => handleCellClick(e, itemData, index, cellIndex)}>
            {itemData}
          </TableDataCells>
        ))}
      </Row>
    )
  }

  return (
    <tbody>
      {/* Render firstRow if provided */}
      {firstRow && Array.isArray(firstRow) && renderRow(firstRow, -1, true)}
      {/* Render regular data */}
      {data?.map((item, index) => renderRow(item, index))}
    </tbody>
  )
}

TableBody.propTypes = {
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.node)]),
}
